export const CREATOR_SITE_ANALYTICS_EVENT = {
  VIEW: 'creator_site_view',
  SECTION_VIEW: 'creator_site_section_view',
  CTA_CLICK: 'creator_site_cta_click',
  OFFER_CLICK: 'creator_site_offer_click',
  LEAD_SUBMIT: 'creator_site_lead_submit',
} as const;

export type CreatorSiteAnalyticsEventName =
  (typeof CREATOR_SITE_ANALYTICS_EVENT)[keyof typeof CREATOR_SITE_ANALYTICS_EVENT];

export const CREATOR_SITE_ANALYTICS_EVENT_NAMES = Object.values(
  CREATOR_SITE_ANALYTICS_EVENT,
) as CreatorSiteAnalyticsEventName[];

export type CreatorSiteAnalyticsUtmParams = {
  utmSource?: string | null;
  utmMedium?: string | null;
  utmCampaign?: string | null;
  utmTerm?: string | null;
  utmContent?: string | null;
};

export type CreatorSiteAnalyticsDevice = 'mobile' | 'desktop' | 'tablet' | 'unknown';

export function isCreatorSiteAnalyticsEventName(
  value: string,
): value is CreatorSiteAnalyticsEventName {
  return (CREATOR_SITE_ANALYTICS_EVENT_NAMES as readonly string[]).includes(value);
}

export function parseCreatorSiteAnalyticsUtm(
  searchParams: URLSearchParams | Record<string, string | undefined | null>,
): CreatorSiteAnalyticsUtmParams {
  const read = (key: string) => {
    const value =
      searchParams instanceof URLSearchParams
        ? searchParams.get(key)
        : searchParams[key] ?? searchParams[key.toLowerCase()];
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed.slice(0, 200) : null;
  };

  return {
    utmSource: read('utm_source'),
    utmMedium: read('utm_medium'),
    utmCampaign: read('utm_campaign'),
    utmTerm: read('utm_term'),
    utmContent: read('utm_content'),
  };
}

export function resolveCreatorSiteAnalyticsDevice(
  viewportWidth: number | null | undefined,
): CreatorSiteAnalyticsDevice {
  if (viewportWidth == null || !Number.isFinite(viewportWidth)) return 'unknown';
  if (viewportWidth < 768) return 'mobile';
  if (viewportWidth < 1024) return 'tablet';
  return 'desktop';
}
